import React, { useState, useEffect } from "react";
import ThemeMaker from "../../components/thememaker";
import { useHistory } from "react-router-dom";
import { Table, Tag } from "antd";
import axios from "axios";
import { IoIosEye } from "react-icons/io";
import { Modal as AntModal } from "antd";
import { config } from "../../utils/config";
import { Button, ConfigProvider, Flex, Tooltip } from 'antd';
import { IoIosInformationCircleOutline } from "react-icons/io";
import moment from "moment";
export default function Inventoryless() {
    const baseUrl = config.apiUrl;
    const history = useHistory();
    const [data, setData] = useState([]);
    const [open, setopen] = useState(false);
    const [biddingData, setBiddingData] = useState([]);
    const [sendata, setsenddata] = useState();
    const [bidModal, setBidModal] = useState(false);
    const [bidAmount, setBidAmount] = useState([])
    const [selectedSession, setSelectedSession] = useState(null);
    console.log("selectedSession--->", selectedSession)
    console.log("bidAmount--->", bidAmount)
    console.log("345678909876543", sendata)
    const columns = [
        {
            title: "Transaction ID",
            dataIndex: "transaction_id",
        },
        {
            title: "Bid Created Date",
            render: (_, record) => <p style={{ width: "100px" }}>{moment((record?.data[0]?.created_at)).format("DD-MM-YYYY hh:mm:ss")}</p>
        },
        {
            title: "Action Required",
            render: (_, record) => {
                if (!record?.data?.length) return "-";

                const hasPending = record.data.some(item =>
                    item?.bidding_quotes?.some(q => !q?.action_taken)
                );

                return hasPending ? <Tag color={"red"}>
                    Yes
                </Tag> : <Tag color={"blue"}>
                    No
                </Tag>;


            }
        },
        {
            title: "Order Created",
            render: (_, record) => {
                if (!record?.data?.length) return "-";

                const hasOrder = record.data.some(item => !!item?.order_id);

                return hasOrder ? <Tag color={"green"}>
                    Yes
                </Tag> : <Tag color={"red"}>
                    No
                </Tag>;
            }
        },
        {
            title: "Order ID",

            render: (_, record) => record?.data?.map((item, index) => {
                return <>
                    {item?.order_id ? <p className="m-0 p-0" style={{ width: "200px" }}> {index + 1}. {item?.order_id}</p> : null}
                </>
            }) || "-"
        },
        {
            title: "No. of products",
            render: (_, record) => record?.data?.length
        },
        {
            title: "Products",
            render: (_, record) => record?.data?.map((item, index) => {
                let text = item.product_details?.attributes?.map(item => {
                    return <><p className="m-0 p-0">{item?.attribute_name}: {item?.attribute_value}</p> </>
                }) || "-"
                return <><div className="d-flex align-items-center" style={{ gap: "5px", width: "200px" }}> <p className="m-0 p-0">{`${index + 1}. `}</p>
                    <p className="m-0 p-0" > {item?.product_details?.name}</p>
                    <Tooltip placement="top" title={text}>
                        <IoIosInformationCircleOutline />
                    </Tooltip>
                </div>
                </>
            }) || "-"
        },
        {
            title: "Warehouses",
            render: (_, record) => record?.data?.map((item, index) => {
                return <>
                    <p className="m-0 p-0" style={{ width: "200px" }}> {index + 1}. {item?.product_details?.warehouse_name},{item?.product_details?.city}</p>
                </>
            }) || "-"
        },


        {
            title: "Price Details",
            // render: (_, record) => <><p className="m-0 p-0" style={{ width: "200px" }}>
            //     <span> base price : {record?.product_details?.base_price}</span> <br />
            //     <span>current price : {record?.product_details?.current_price}</span>   <br />
            //     <span> minimum price : {record?.product_details?.minimum_price}</span>  <br />
            //     <span> maximum price : {record?.product_details?.maximum_price}</span>  <br />
            // </p>
            // </>
            //     || "-"

            render: (_, record) => record?.data?.map((item, index) => {
                let text = <><p className="m-0 p-0" style={{ width: "200px" }}>
                    <span> base price : Rs {item?.product_details?.base_price}</span> <br />
                    <span>current price : Rs {item?.product_details?.current_price}</span>   <br />
                    <span> minimum price : Rs {item?.product_details?.minimum_price}</span>  <br />
                    <span> maximum price : Rs {item?.product_details?.maximum_price}</span>  <br />
                </p> </>

                return <><div className="d-flex align-items-center" style={{ gap: "5px", width: "200px" }}> <p className="m-0 p-0">{`${index + 1}. `}</p>
                    <p className="m-0 p-0" > {item?.product_details?.name}</p>
                    <Tooltip placement="top" title={text}>
                        <IoIosInformationCircleOutline />
                    </Tooltip>
                </div>
                </>
            }) || "-"
        },
        {
            title: "Bid Status",
            dataIndex: "status",
            render: (status) => (
                <Tag color={status === "ACTIVE" ? "green" : "red"}>
                    {status}
                </Tag>
            ),
        },

        {
            title: "Action",
            render: (_, record) => (
                <IoIosEye
                    style={{ cursor: "pointer", fontSize: "18px" }}
                    onClick={() => {
                        setSelectedSession(record);   // store transaction_id & item_id
                        let t = record.data.map(item => item?.bidding_quotes)
                        console.log("t-------->", t)
                        let z = t.flat(1)
                        console.log("z-------->", z)
                        const sorted = z.sort((a, b) => a.round_number - b.round_number);
                        setBiddingData(sorted || []);
                        setopen(true);
                    }}
                />
            )
        }
    ];



    const handlesendapi = async (actionType, data) => {
        let payload;
        console.log(actionType)
        if (actionType !== "reject")
            payload = {
                transaction_id: selectedSession?.transaction_id,
                // item_id: selectedSession?.item_id,
                action: actionType,
                // seller_bid: actionType === "ACCEPT" ? bidAmount : "",
                items: bidAmount
            };
        if (actionType === "REJECT")

            payload = {
                transaction_id: selectedSession?.transaction_id,
                // item_id: selectedSession?.item_id,
                action: actionType,
                // seller_bid: actionType === "ACCEPT" ? bidAmount : "",
                items: data?.map(item => { return { "seller_bid": 0, item_id: item?.item_id } })
            };

        console.log("payload--->", payload)
        // return

        try {
            const response = await axios({
                url: `${config.baseNodeapiUrl}/invl/admin_dashboard_seller_bid_action`,
                method: "POST",
                data: payload
            });

            console.log("API Response:", response.data);
            setopen(false)
            setBidModal(false);
            setBidAmount([]);
            getAllwarehouse();

        } catch (error) {
            console.log(error);
        }

    };

    const biddingColumns = [
        {
            title: "Round Number",
            dataIndex: "round_number",
        },
        {
            title: "Item Name",
            dataIndex: "item_name",
        },

        {
            title: "Item ID",
            dataIndex: "item_id",
        },


        {
            title: "Lowest Bid",
            dataIndex: "lowest_bid",
            render: (val) => val ?? "-"
        },
        {
            title: "Seller Bid",
            dataIndex: "seller_bid",
            render: (val) => val ?? "-"
        },
        {
            title: "Action Taken",
            dataIndex: "action_taken",
            render: (val) => (val ? "Yes" : "No")
        },
        {
            title: "Seller Action",
            dataIndex: "seller_action",
            render: (val) => val ?? "-"
        },
        {
            title: "Action At",
            dataIndex: "action_at",
            render: (val) => val ? new Date(val).toLocaleString() : "-"
        },
        {
            title: "Created At",
            dataIndex: "created_at",
            render: (val) => new Date(val).toLocaleString()
        },

    ];

    const getAllwarehouse = async () => {
        try {
            const response = await axios({
                url: `${config.baseNodeapiUrl}/invl/getBiddingSessions`,
                method: "POST",
            });

            setData(response?.data?.data || []);
            const passdata = response?.data?.data
            console.log("wertyuiop--->", response?.data?.data)
            setsenddata(response?.data?.data);
        } catch (error) {
            console.log("Error -------->", error);
        }
    };

    useEffect(() => {
        getAllwarehouse();
    }, []);

    // const filteredBiddingData = biddingData.filter(item => item.round_number > 0);



    return (
        <ThemeMaker>

            <div className=" m-0 mt-1">
                <div className="p-2">
                    <div className="" style={{ width: "100%", height: "80vh", overflowY: "scroll" }}>

                        <Table
                            columns={columns}
                            dataSource={data}
                            rowKey="id"
                            style={{ width: "100%" }}
                        />

                    </div>
                </div>
            </div>

            <AntModal className="mt-5"
                title="Bidding Details"
                open={open}
                onCancel={() => setopen(false)}
                footer={null}
                centered
                width={1200}
            >


                <Table
                    columns={biddingColumns}
                    dataSource={biddingData}
                    rowKey="id"
                    pagination={false}
                    style={{ maxHeight: "350px", overflow: "scroll" }}
                // scroll={{ y: 300 }}
                />

                <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
                    <button
                        style={{
                            background: "green",
                            color: "white",
                            border: "none",
                            padding: "5px 10px",
                            borderRadius: "4px"
                        }}
                        onClick={() => setBidModal(true)}
                    >
                        Accept
                    </button>

                    <button
                        style={{
                            background: "red",
                            color: "white",
                            border: "none",
                            padding: "5px 10px",
                            borderRadius: "4px"
                        }}
                        onClick={() => handlesendapi("REJECT", biddingData)}
                    >
                        Reject
                    </button>
                </div>

            </AntModal>

            <AntModal
                title="Enter Bid Amount"
                open={bidModal}
                onCancel={() => setBidModal(false)}
                centered
                footer={null}
            >
                {
                    selectedSession?.data?.map(item => {
                        return <>

                            <input
                                type="number"
                                placeholder={`bid amount ${item?.product_details?.name}`}
                                onChange={(e) => {
                                    const value = Number(e.target.value);
                                    const item_id = item?.item_id;

                                    setBidAmount((prev) => {
                                        const existing = prev.find(i => i.item_id === item_id);

                                        if (existing) {
                                            return prev.map(i =>
                                                i.item_id === item_id ? { ...i, seller_bid: value } : i
                                            );
                                        } else {
                                            return [...prev, { item_id: item_id, seller_bid: value }];
                                        }
                                    });
                                }}
                                style={{
                                    width: "100%",
                                    padding: "8px",
                                    border: "1px solid #ccc",
                                    borderRadius: "5px",
                                    marginTop: "10px"
                                }}
                            />
                        </>
                    })
                }

                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                >
                    <button
                        style={{
                            padding: "5px 10px",
                            color: "white",
                            background: "blue",
                            borderRadius: "10px",
                            border: "none",
                            margin: "10px"
                        }}

                        onClick={() => handlesendapi("ACCEPT")}
                    >Submit</button>
                </div>
            </AntModal>

        </ThemeMaker>
    );
}